module.exports = __webpack_public_path__ + "img/en-5.60bf1a6b.jpg";